import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/core/api/api.service';

@Injectable({ providedIn: 'root' })
export class DescuentosService {

  private readonly base = '/transactions/discounts';

  constructor(private api: ApiService) {}

  // `token` es legacy y se ignora (el token va en el header Bearer).

  listarDescuentos(_token: string, params: {
    fechaInicio: string; fechaFin: string;
    start: number; length: number; search: string;
  }): Observable<{ data: any[]; recordsTotal: number; recordsFiltered: number }> {
    return this.api.post(`${this.base}/list`, params);
  }

  crearDescuento(datos: any): Observable<{ secuencial: any }> {
    return this.api.post(`${this.base}/create`, datos);
  }

  eliminarDescuento(id: number): Observable<{ id: number }> {
    return this.api.post(`${this.base}/delete`, { id });
  }
}
